import React from "react"

const testimonials = [
  {
    quote:
      "Easy setup, amazing support, and real results. Plus the extra affiliate income helps me reinvest in better equipment for my clients!",
    name: "Lisa",
    profession: "Christian Coach",
  },
  {
    quote:
      "Zoee feels like a true business partner. They genuinely care about my success and remember our previous conversations every time I call.",
    name: "Amanda",
    profession: "Grief Coach",
  },

  {
    quote:
      "I love the ease of use and ability to create a personal webpage with multimedia including blogs and videos. The interface is super clean for both clients and coaches and admin is pretty darn simple.",
    name: "Jimmy G.",
    profession: "Executive Coach",
  },

  {
    quote:
      "Zoee is an amazing platform for coaches to spend more time doing what they LOVE - coach their clients and less time on the calendar worrying about invoicing and scheduling overlaps.",
    name: "Bernadette",
    profession: "Business Consultant",
  },
  {
    quote:
      "Within my first month using Zoee, I booked 8 new clients. The automated scheduling is a game-changer for my practice.",
    name: "Mike",
    profession: "Life Coach",
  },

  {
    quote:
      "The Zoee platform contains an all-in-one solution for coaches: webpage, client management, booking, payments, scheduling, notes, and more. Plus, tech support is SUPER responsive.",
    name: "LeeAnn",
    profession: "Executive Coach",
  },
  {
    quote:
      "All my needs in one place! As soon as I heard about all the features Zoee offered, I was sold. I was tired to logging into and juggling multiple sites to run my business. The setup and utilization of Zoee has been so simple and honestly fun to use. I'm excited to connect and support other coaches on this journey!",
    name: "Tonya",
    profession: "Life Coach",
  },
  {
    quote:
      "When I first heard about Zoee, I could not believe that all of my needs could be met with just one platform! I met with Nichole and was instantly hooked. Her vision and creation is what every coach needs to run a successful business. As a Founding Coach, it's been so great to instantly feel part of a team as I create my website, calendar, set up my paywalls, and meet with clients!",
    name: "Jessica",
    profession: "Professional Coach",
  },
]

const CoachTestimonials = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      {testimonials.map((t, i) => (
        <div
          key={i}
          className="bg-gradient-to-br from-white via-[#F9FAFB] to-[#F0F4FF] p-6 rounded-3xl shadow-lg border border-gray-200 flex flex-col justify-between h-full transition hover:shadow-xl"
        >
          <p className="text-gray-800 text-base italic leading-relaxed mb-4">
            “{t.quote}”
          </p>
          <div className="mt-auto pt-3 border-t border-gray-200">
            <p className="text-sm font-semibold text-black mt-2">{t.name}</p>
            <p className="text-xs tracking-wide text-blurple uppercase">
              {t.profession}
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default CoachTestimonials
